import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

Vue.use(VueRouter);

import Login from '../views/Login.vue';
import Register from '../views/Register.vue';
import MainLayout from '../views/MainLayout.vue';
import Dashboard from '../views/Dashboard.vue';
import ResourceForm from '../views/ResourceForm.vue';
import Sales from '../views/Sales.vue';
import Profile from '../views/Profile.vue';
import Withdraw from '../views/Withdraw.vue';
import RemovedResources from '../views/RemovedResources.vue';

const routes = [
  { path: '/login', name: 'Login', component: Login },
  { path: '/register', name: 'Register', component: Register },
  {
    path: '/',
    component: MainLayout,
    redirect: '/resources',
    children: [
      { path: 'resources', name: 'Dashboard', component: Dashboard, meta: { tab: 0 } },
      { path: 'resources/new', name: 'ResourceNew', component: ResourceForm, meta: { tab: 0 } },
      { path: 'resources/:id/edit', name: 'ResourceEdit', component: ResourceForm, meta: { tab: 0 } },
      { path: 'resources/removed', name: 'RemovedResources', component: RemovedResources, meta: { tab: 0 } },
      { path: 'sales', name: 'Sales', component: Sales, meta: { tab: 1 } },
      { path: 'profile', name: 'Profile', component: Profile, meta: { tab: 2 } },
      { path: 'withdraw', name: 'Withdraw', component: Withdraw, meta: { tab: 2 } }
    ]
  }
];

const router = new VueRouter({ mode: 'hash', routes });

router.beforeEach((to, from, next) => {
  const publicPages = ['Login', 'Register'];
  if (!publicPages.includes(to.name) && !store.state.token) {
    next({ name: 'Login', query: { redirect: to.fullPath } });
  } else {
    next();
  }
});

export default router;
